import { nanoid } from 'nanoid'

/* @ngInject */
function conditionalService () {
  const service = {
    createNewConditionalAction,
    validateConditionalFields,
    validateInconsistentConditionals,
    removeOptionFromConditional,
    getConditionalActionsCount,
    setConditionals,
    findLastFieldWithConditional,
    areThereTypeConditional,
    findActionByOptionId,
    getNextSectionFromConditional,
    handleConditionalFieldValue
  }
  return service

  function createNewConditionalAction () {
    return {
      id: nanoid(),
      options: [],
      type: null,
      sectionId: null,
      typeObj: null,
      initialOptions: []
    }
  }

  function validateConditionalFields (briefing) {
    const hasInvalidConditional = briefing.sections.some(section => {
      let invalidConditionalField = false
      let index = 0
      while (!invalidConditionalField && index < section.fields.length) {
        if (section.fields[index].hasInvalidConditionalFields && section.fields[index].hasConditional) {
          section.fields[index].inconsistentAction = true
          invalidConditionalField = true
        } else {
          index++
        }
      }

      return invalidConditionalField
    })

    return hasInvalidConditional
  }

  function validateInconsistentConditionals (briefing, type) {
    if (type === 'AUDIT') return false

    const hasInconsistentConditional = briefing.sections.some(section => {
      let inconsistentConditionalField = false
      let index = 0
      while (!inconsistentConditionalField && index < section.fields.length) {
        const hasConditional = section.fields[index].hasConditional
        let hasInconsistentCondition = false

        if (section.fields[index].actions) {
          hasInconsistentCondition = section.fields[index].actions.some(action => action.sectionId === section.id)
        }

        if (hasConditional && hasInconsistentCondition) {
          inconsistentConditionalField = true
        } else {
          index++
        }
      }

      return inconsistentConditionalField
    })

    return hasInconsistentConditional
  }

  function setConditionals (briefing) {
    briefing.sections.forEach(section => {
      section.fields.forEach(field => {
        field.hasConditional = field.actions.length > 0

        if (field.hasConditional) {
          field.actions.forEach(action => {
            action.initialOptions = []
          })
        }
      })
    })
  }

  function removeOptionFromConditional (field, optionValue) {
    if (!field.actions || !field.actions.length) return

    field.actions.forEach(action => {
      const index = action.options.findIndex((item) => {
        return parseInt(optionValue) === item.id || optionValue === item.title || optionValue === item.label || parseInt(optionValue) === item.value
      })

      if (index !== -1) {
        action.options.splice(index, 1)
      }
    })
  }

  function getConditionalActionsCount (briefing) {
    let count = 0

    briefing.sections.forEach(section => {
      section.fields.forEach(field => {
        if (field.actions && field.actions.length) {
          count++
        }
      })
    })

    return count
  }

  function findLastFieldWithConditional (section) {
    let lastFieldWithConditional = null
    let lastFieldWithFilledConditional = null
    let i = section.fields.length - 1

    for (i; i >= 0; i--) {
      if (section.fields[i].actions && section.fields[i].actions.length) {
        if (!lastFieldWithConditional) {
          lastFieldWithConditional = section.fields[i]
        }

        if (!lastFieldWithFilledConditional && section.fields[i].value) {
          lastFieldWithFilledConditional = section.fields[i]
        }
      }
    }

    return lastFieldWithFilledConditional || lastFieldWithConditional
  }

  function areThereTypeConditional (type, actions) {
    return actions.some(action => action.type === type)
  }

  function findActionByOptionId (optionValue, actions) {
    if (Array.isArray(optionValue)) optionValue = optionValue[0]

    const action = actions.find(action => {
      const hasOption = action.options.some(option => option.title === optionValue || option.id === optionValue)
      const hasAsset = action.assetOptions.some(option => option.asset.files[0].name === optionValue || option.assetId === optionValue)
      return hasOption || hasAsset
    })

    return action
  }

  function getNextSectionFromConditional (conditionalField, currentSectionId, sections) {
    let selectedSection = null
    let selectedAction = null
    if (conditionalField?.value) {
      selectedAction = this.findActionByOptionId(conditionalField?.value, conditionalField.actions)
      if (selectedAction) {
        selectedSection = sections.find(section => section.id === selectedAction.sectionId)
      }
    }

    if (!conditionalField || !conditionalField.value || !selectedSection || !selectedAction) {
      const currentSectionIndex = sections.findIndex(section => section.id === currentSectionId)

      if (currentSectionIndex !== -1) {
        selectedSection = sections[currentSectionIndex + 1]
      }
    }

    return selectedSection
  }

  function handleConditionalFieldValue (field) {
    if (field.value === 'SELECTED' && field.field_values?.length) {
      field.value = field.field_values[0].metadata[0].title
    } else if (Array.isArray(field.value)) {
      field.value = field.value[0]
    }
  }
}

export { conditionalService }
